import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    width: '30px',
    height: '30px',
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
  },
});

export default useSx;
